/* jshint -W003 */

// eslint-disable-next-line max-statements
(function ($) {

  var keyEnter = 13;
  var keyShift = 16;
  var keyLeft = 37;
  var keyUp = 38;
  var keyRight = 39;
  var keyDown = 40;

  var doneTypingInterval = 10;
  var typingTimer;
  var topicParam = 'topic=';

  function getSearchText() {
    return $('#search-box-input').val().replace(/(<([^>]+)>)/ig, '');
  }

  function getSearchSuggestionsUrl(query) {
    return requestContext.hostPath + '/ajax/suggest?q=' + query + getProgId();
  }

  function getTopicId() {
    var topic = $('#search-box-topic').val();
    if (topic) {
      return topic;
    }

    var params = window.location.search.split('&');
    for (var i = 0, len = params.length; i < len; i++) {
      var param = params[i];
      if (param.indexOf(topicParam) === 0) {
        return param.substr(topicParam.length);
      }
    }
    return '';
  }

  function getSearchScope() {
    var searchScope = '';

    var params = window.location.search.split('&');
    params.forEach(function (param) {
      if (param.indexOf('path=') !== -1) {
        searchScope += '&' + param;
      }
    });

    var topicParam = getTopicId();
    if (topicParam) {
      searchScope += '&topic=' + topicParam;
    }

    return searchScope;
  }

  function getProgId() {
    if (requestContext.plId === '1') { return ''; }
    return '&prog_id=' + requestContext.progId;
  }

  function searchSuggestionClick(evt) {
    var item = $(evt.currentTarget);
    var pos = item.attr('data-pos');
    var query = item.attr('data-query');
    var href = requestContext.hostPath + '/search?q=' + query + getSearchScope() + getProgId();

    query = query.replace(/[,^]/g, '');
    if (query) {
      ux.traffic.custom('search', 'mcx.help.search.suggest.click', [
        ['query', query],
        ['pos', pos],
        ['topic', requestContext.searchScopeStrId],
        ['name', requestContext.searchScope],
        ['inapp', gdhelp2.utils.inIframe()],
        ['plId', requestContext.plId]
      ]);
    }

    setTimeout(function () {
      window.location = href;
    }, 150);
  }

  function showSearchSuggestions(data) {
    var suggestionsList = $('#search-box-results');

    if (data.length > 0) {
      var query = getSearchText();
      var suggestions = '';

      $.each(data, function (i, item) {
        item.text = item.text.replace(/"/g, '\'');
        var suggestion = item.text.replace(query, `<strong>${query}</strong>`);
        suggestions += `<a class="dropdown-item" href="#" data-pos="${(i + 1)}" data-query="${item.text}" ><span>${suggestion}</span></a>`;
      });

      suggestionsList.html(suggestions);
      suggestionsList.attr('data-selected', -1);
      $('#search-box-results a').on('click', searchSuggestionClick);

      if (!$('#search-box-dropdown').is(':visible')) {
        $('#search-box-dropdown').show();

        if (ux.traffic && ux.traffic.impression) {
          ux.traffic.impression('mcx.help.search.suggest.impression');
        }
      }
    } else {
      hideSearchSuggestions();
      suggestionsList.html('');
    }
  }

  function hideSearchSuggestions() {
    $('#search-box-dropdown').hide();
  }

  function selectSearchSuggestions(offset) {
    if (!$('#search-box-dropdown').is(':visible')) {
      return;
    }

    var suggestionsList = $('#search-box-results');
    var listLength = suggestionsList.children().length;
    var selectedIndex = parseInt(suggestionsList.attr('data-selected'), 10);

    var newIndex = selectedIndex + offset;
    if (newIndex < 0) {
      newIndex = 0;
    } else if (newIndex > (listLength - 1)) {
      newIndex = (listLength - 1);
    }

    $('#search-box-results a').each(function (i) {
      var item = $(this);
      item.removeClass('selected');
      if (i === newIndex) {
        item.addClass('selected');
        $('#search-box-input').val(item.text());
      }
    });

    suggestionsList.attr('data-selected', newIndex);
  }

  function getSearchSuggestionsResponse(resp) {
    if (resp.status === 200 && resp.responseText) {
      var data = JSON.parse(resp.responseText);
      if (data && data[0]) {
        showSearchSuggestions(data[0]);
      }
    }
  }

  function doneTyping() {
    var searchText = getSearchText();
    if (searchText.length > 0) {
      $.ajax({ type: 'GET', url: getSearchSuggestionsUrl(searchText) })
        .complete(getSearchSuggestionsResponse);
    }
  }

  function logSearch(query, submitType) {
    if (!submitType || !query) { return; }

    // eslint-disable-next-line no-useless-escape
    query = query.replace(/[,\^]/g, '');
    if (!query) { return; }

    ux.traffic.custom('search', 'mcx.help.search', [
      ['query', query],
      ['topic', requestContext.searchScopeStrId],
      ['name', requestContext.searchScope],
      ['submit', submitType],
      ['inapp', gdhelp2.utils.inIframe()],
      ['plId', requestContext.plId]
    ]);
  }

  function getSearchUrl(searchText) {
    var searchForm = $('#search-box-form');
    if (searchForm.length) {
      var action = searchForm.attr('action');
      var topic = $('#search-box-topic').val();
      var page = $('#search-box-form-page').val();
      var url = action + '?q=' + searchText + '&topic=' + topic + '&pg=' + page + getProgId();
      return url;
    }

    return null;

  }

  function submitSearch(searchText, searchPath) {
    setTimeout(function () {
      if (window.gdInappHelp && window.gdInappHelp.notifySearch) {
        window.gdInappHelp.notifySearch(getSearchUrl(searchText));
      }
      $('#search-box-input').val(searchText);
      $('#search-box-path').val(searchPath);
      $('#search-box-topic').val(getTopicId());
      $('#search-box-form').submit();
    }, 100);
  }

  function searchIconOnClick() {
    submitSearchType('click');
    return false;
  }

  function searchBoxInputOnKeyDown(e) {
    var key = e.which;
    if (key === keyEnter) {
      submitSearchType('enter');
      return false;
    } else if (key === keyDown) {
      selectSearchSuggestions(1);
      return false;
    } else if (key === keyUp) {
      selectSearchSuggestions(-1);
      return false;
    }
  }

  function searchBoxInputOnKeyUp(e) {
    var key = e.which;
    if (key !== keyShift && key !== keyEnter && key !== keyLeft && key !== keyRight &&
        key !== keyUp && key !== keyDown) {
      clearTimeout(typingTimer);
      if ($('#search-box-input').val()) {
        typingTimer = setTimeout(doneTyping, doneTypingInterval);
      } else {
        $('#search-box-dropdown').hide();
      }
    }
  }

  function setSearchFilterPath(path) {
    path = path || '';
    var filterOptions = path.split('');

    $('#search-path-help').attr('checked',
      (filterOptions.indexOf('h') !== -1));
    $('#search-path-community').attr('checked',
      (filterOptions.indexOf('c') !== -1));
    $('#search-path-blog').attr('checked',
      (filterOptions.indexOf('b') !== -1));
    $('#search-path-fos').attr('checked',
      (filterOptions.indexOf('f') !== -1));
  }

  function getSearchFilterPath() {
    var searchFilter = $('.search-filter');
    if (searchFilter.length) {
      var filterOptions = [];

      if ($('#search-path-help').attr('checked')) {
        filterOptions.push('h');
      }
      if ($('#search-path-community').attr('checked')) {
        filterOptions.push('c');
      }
      if ($('#search-path-blog').attr('checked')) {
        filterOptions.push('b');
      }
      if ($('#search-path-fos').attr('checked')) {
        filterOptions.push('f');
      }

      if (filterOptions.length === 0) {
        return 'none';  // filter on page and none selected
      }

      return filterOptions.join(''); // filter selection

    }

    return ''; // filter not on page, default

  }

  function clearResults() {
    $('.search-results').empty();
    $('.search-results-pagination').hide();
    $('.total-results').html('0');
  }

  function searchPathFilterOnClick() {
    submitSearchType('filter');
    return true;
  }

  function filterToggleOnClick() {
    var searchFilterBar = $('.filter-bar');
    if (searchFilterBar) {
      if (searchFilterBar.hasClass('expanded')) {
        $('.filter-arrow').removeClass('rotate-180');
        searchFilterBar.removeClass('expanded');
      } else {
        $('.filter-arrow').addClass('rotate-180');
        searchFilterBar.addClass('expanded');
      }
    }
  }

  function submitSearchType(submitType) {
    var searchText = getSearchText();
    if (searchText.length > 0) {
      var searchPath = getSearchFilterPath();
      if (searchPath === 'none') {
        clearResults();
      } else {
        logSearch(searchText, submitType);
        submitSearch(searchText, searchPath);
      }
    }
  }

  function initSearchFilter() {
    var searchFilter = $('.search-filter');
    if (searchFilter.length) {
      var path = $('#search-box-path').val();
      setSearchFilterPath(path);
      searchFilter.show();
    }
  }

  function ready() {
    initSearchFilter();
  }

  $('#search-box-input').on('keydown', searchBoxInputOnKeyDown);
  $('#search-box-input').on('keyup', searchBoxInputOnKeyUp);
  $('#search-box-icon').on('click', searchIconOnClick);
  $(window).on('click', hideSearchSuggestions);
  $('#search-path-help').on('click', searchPathFilterOnClick);
  $('#search-path-community').on('click', searchPathFilterOnClick);
  $('#search-path-blog').on('click', searchPathFilterOnClick);
  $('#search-path-fos').on('click', searchPathFilterOnClick);
  $('#filter-toggle-button').on('click', filterToggleOnClick);
  $(document).ready(ready);

}(jQuery));

/* jshint +W003 */
